module.exports = __webpack_public_path__ + "img/plans.e9279474.svg";